module.exports = __webpack_public_path__ + "static/img/Oak Oyster.12352a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Oak Oyster.jpg
// module id = 01MT
// module chunks = 0